import { useCallback, useState } from 'react';

const EMPTY = { open: false, ids: [], label: '' };

/** Shared delete-confirm state (Faristalo-style modal, Qawaem ERP shell). */
export function useCrudDeleteConfirm() {
  const [deleteConfirm, setDeleteConfirm] = useState(EMPTY);

  const closeDeleteConfirm = useCallback(() => setDeleteConfirm(EMPTY), []);

  const openDeleteOne = useCallback((id, label = '') => {
    setDeleteConfirm({ open: true, ids: [id], label });
  }, []);

  const openBulkDelete = useCallback((ids, label = '') => {
    if (!ids?.length) return;
    setDeleteConfirm({ open: true, ids: [...ids], label });
  }, []);

  const takePendingIds = useCallback(() => {
    const ids = deleteConfirm.ids;
    setDeleteConfirm(EMPTY);
    return ids;
  }, [deleteConfirm.ids]);

  return {
    deleteConfirm,
    closeDeleteConfirm,
    openDeleteOne,
    openBulkDelete,
    takePendingIds,
  };
}
